import { render, staticRenderFns } from "./ImageAttachFooterRoomComponents.vue?vue&type=template&id=2f656a1f&scoped=true&"
import script from "./ImageAttachFooterRoomComponents.vue?vue&type=script&lang=js&"
export * from "./ImageAttachFooterRoomComponents.vue?vue&type=script&lang=js&"
import style0 from "./ImageAttachFooterRoomComponents.vue?vue&type=style&index=0&id=2f656a1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.24._f07fc21c0eeec7f6e04fb4ae2769cbbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f656a1f",
  null
  
)

export default component.exports